import { getBridgeRoot } from '../../files/cwd/index.js';
import type { SessionWorktreeBinding } from '../session-worktree-binding.js';
import type { SessionWorktreeCache } from './session-worktree-cache.js';

function bridgeRootBinding(bridgeRoot: string): SessionWorktreeBinding {
  return {
    sessionParentPath: bridgeRoot,
    repoCheckoutPaths: [bridgeRoot],
  };
}

export async function resolveCommitTargetsAsync(
  sessionId: string,
  cache: SessionWorktreeCache,
  discover: (sessionId: string) => Promise<SessionWorktreeBinding | null>,
): Promise<string[]> {
  const sid = sessionId.trim();
  const paths = cache.getRepoCheckoutPathsRef(sid);
  if (paths?.length) return paths;

  const disc = await discover(sid);
  if (disc?.repoCheckoutPaths.length) {
    cache.remember(sid, disc);
    return disc.repoCheckoutPaths;
  }

  const bridgeRoot = getBridgeRoot();
  cache.remember(sid, bridgeRootBinding(bridgeRoot));
  return [bridgeRoot];
}
